var map = {
	"./contemporary-wall-mounted-pooja-unit-with-backlighting.jpg": 17455,
	"./designer-pooja-room.jpg": 17864,
	"./glass-door-for-pooja-room.jpg": 4066,
	"./mandir-design-for-home.jpg": 60313,
	"./mandir-jali-design.jpg": 58388,
	"./mandir-jali-designs.jpg": 78599,
	"./marble-wall-tiles-for-pooja-room-designs.jpg": 70603,
	"./marble-wall-tiles.jpg": 86439,
	"./modern-marble-pooja-mandir-designs-for-home.jpg": 62893,
	"./modern-marble-pooja-mandir-designs-for-homes.jpg": 21821,
	"./modern-style-pooja-unit-design-with-wooden-finish.jpg": 330,
	"./pooja-ghar-design.jpg": 49096,
	"./pooja-mandir-designs.jpg": 82563,
	"./pooja-mandir-for-home.jpg": 81993,
	"./pooja-room-decoration.jpg": 36471,
	"./pooja-room-design-for-home.jpg": 36763,
	"./pooja-room-designs-in-marble.jpg": 92008,
	"./pooja-room-designs-in-marbles.jpg": 41489,
	"./pooja-room-designs.jpg": 87037,
	"./pooja-room-interior-design.jpg": 56445,
	"./pooja-shelf-design.jpg": 4980,
	"./pooja-shelf-designs.jpg": 65128,
	"./pooja-unit-design.jpg": 84277,
	"./puja-mandir-designs.jpg": 6999,
	"./simple-pooja-room-designs.jpg": 66095,
	"./small-pooja-room-design.jpg": 810,
	"./small-pooja-room-designs-for-home.jpg": 83785,
	"./small-pooja-room-designs-for-homes.jpg": 41835,
	"./small-pooja-room-designs-for-indian-homes.jpg": 58359,
	"./small-pooja-room-designs-in-apartment.jpg": 50980,
	"./small-pooja-room-designs-in-apartments.jpg": 14462,
	"./small-pooja-room-designs.jpg": 1352,
	"./stylish-modern-mandir-design.jpg": 89236,
	"./traditional-pooja-room-with-wooden-storage-unit.jpg": 95117,
	"./traditional-wooden-pooja-mandir-designs-for-home.jpg": 21812,
	"./traditional-wooden-pooja-mandir-designs-for-homes.jpg": 53443,
	"./wallpaper-for-pooja-room.jpg": 72480,
	"./wallpaper-for-pooja-roome.jpg": 24799,
	"./wallpaper-for-pooja-rooms.jpg": 78868,
	"./white-marble-temple-for-home.jpg": 32249,
	"./wooden-mandir-designs.jpg": 52942,
	"./wooden-pooja-mandir-designs-for-home.jpg": 77122,
	"./wooden-pooja-mandir-designs-for-homes.jpg": 70637,
	"./wooden-pooja-mandir-designs-for-homew.jpg": 35270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5881;